import React, { useMemo } from 'react';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
import { StepsSlideContext } from "../../context";
var cx = classNames.bind(styles);
export var PrimaryContent = function PrimaryContent(_ref) {
  var children = _ref.children,
    index = _ref.index,
    isActive = _ref.isActive,
    className = _ref.className,
    onClick = _ref.onClick;
  var contextValue = useMemo(function () {
    return {
      isActive: isActive,
      index: index
    };
  }, [isActive, index]);
  return /*#__PURE__*/React.createElement("button", {
    className: cx('step', {
      'step-active': isActive
    }, className),
    onClick: onClick,
    type: "button",
    "data-t-id": "components-PrimaryContent"
  }, /*#__PURE__*/React.createElement(StepsSlideContext.Provider, {
    value: contextValue
  }, children), /*#__PURE__*/React.createElement("div", {
    className: cx('number')
  }, index + 1));
};